<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.id || index" :row-index="index + 1">
      <van-row class="detail-row">
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>开单周期(天)：</span>
        <span>{{ item.cycle }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>有效期始：</span>
        <span>{{ item.startDate }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>有效期至：</span>
        <span>{{ item.endDate }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'DeliveryAdvanceApplyDetailList',
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-row span:first-child {
  color: #666666;
}
.detail-row span:last-child {
  color: #262626;
}
</style>
